export const sentimentChoices = [
  { id: "1bb7968a-6767-43e0-8c9a-cce4ae10ba29", name: "POSITIVE" },
  { id: "cb9cc836-de1a-4369-b792-2dd2df6ef775", name: "NEUTRAL" },
  { id: "40d052b9-53c1-4145-b643-a98fa5d8180f", name: "NEGATIVE" },
  { id: "99342b10-ef7a-4036-9aac-f57e03c2d829", name: "DANGER" },
];
